import { render, staticRenderFns } from "./RTreeSimple.vue?vue&type=template&id=cc8bf68e&scoped=true"
import script from "./RTreeSimple.vue?vue&type=script&lang=js"
export * from "./RTreeSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8bf68e",
  null
  
)

export default component.exports